import React from 'react';
import ParallaxSection from './ParallaxSection';
import SectionHeading from './SectionHeading';
import MediaGallery from './MediaGallery';

const MediaSection: React.FC = () => {
  return (
    <>
    <ParallaxSection
      id="impressionen"
      backgroundImage="/images/Flugsportverein_Bilder_3.jpg"
    >
      <div>
        <SectionHeading
          eyebrow="Impressionen"
          title="Erleben Sie unsere Aktivitäten"
          subtitle="Sehen Sie selbst, wie aufregend und vielfältig das Fliegen bei uns ist. Folgen Sie uns auch auf Facebook für weitere Einblicke!"
          className="mb-0"
        />

        <div className="mt-10 flex justify-center">
          <div className="w-full max-w-4xl">
            <div className="relative w-full" style={{ paddingBottom: '56.25%' /* 16:9 aspect ratio */ }}>
              <iframe 
                src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FMDRThueringen%2Fvideos%2F1843086322540891%2F&show_text=false&width=560&t=0" 
                className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
                style={{ border: 'none', overflow: 'hidden' }} 
                scrolling="no" 
                frameBorder="0" 
                allowFullScreen={true} 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title="Facebook Video - Flugsportverein Otto Lilienthal"
              />
            </div>
            
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-600 mb-4">
                Folgen Sie uns auf Facebook für weitere Videos und aktuelle Neuigkeiten!
              </p>
            </div>
          </div>
        </div>
      </div>
    </ParallaxSection>
    <MediaGallery />
    </>
  );
};

export default MediaSection; 